import * as actionTypes from "./actionTypes";

export const loadLuckyDrawCount = data => ({
  type: actionTypes.LOAD_LUCKY_DRAW_COUNT,
  data
});

export const loadLuckyDrawCountSuccess = data => ({
  type: actionTypes.LOAD_LUCKY_DRAW_COUNT_SUCCESS,
  data
});

export const loadLuckyDrawCountFail = () => ({
  type: actionTypes.LOAD_LUCKY_DRAW_COUNT_FAIL
});

export const loadLuckyDrawList = data => ({
  type: actionTypes.LOAD_LUCKY_DRAW_LIST,
  data
});

export const loadLuckyDrawListSuccess = data => ({
  type: actionTypes.LOAD_LUCKY_DRAW_LIST_SUCCESS,
  data
});

export const loadLuckyDrawListFail = () => ({
  type: actionTypes.LOAD_LUCKY_DRAW_LIST_FAIL
});

export const loadLuckyDrawDetail = (id, data) => ({
  type: actionTypes.LOAD_LUCKY_DRAW_DETAIL,
  id,
  data
});

export const loadLuckyDrawDetailSuccess = data => ({
  type: actionTypes.LOAD_LUCKY_DRAW_DETAIL_SUCCESS,
  data
});

export const loadLuckyDrawDetailFail = () => ({
  type: actionTypes.LOAD_LUCKY_DRAW_DETAIL_FAIL
});

export const createLuckyDraw = data => ({
  type: actionTypes.CREATE_LUCKY_DRAW,
  data
});

export const createLuckyDrawSuccess = data => ({
  type: actionTypes.CREATE_LUCKY_DRAW_SUCCESS,
  data
});

export const createLuckyDrawFail = () => ({
  type: actionTypes.CREATE_LUCKY_DRAW_FAIL
});

export const updateLuckyDraw = (id, data) => ({
  type: actionTypes.UPDATE_LUCKY_DRAW,
  id,
  data
});

export const updateLuckyDrawSuccess = () => ({
  type: actionTypes.UPDATE_LUCKY_DRAW_SUCCESS
});

export const updateLuckyDrawFail = () => ({
  type: actionTypes.UPDATE_LUCKY_DRAW_FAIL
});

export const updateLuckyDrawActive = (id, data) => ({
  type: actionTypes.UPDATE_LUCKY_DRAW_ACTIVE,
  id,
  data
});

export const updateLuckyDrawActiveSuccess = () => ({
  type: actionTypes.UPDATE_LUCKY_DRAW_ACTIVE_SUCCESS
});

export const updateLuckyDrawActiveFail = () => ({
  type: actionTypes.UPDATE_LUCKY_DRAW_ACTIVE_FAIL
});

export const removeLuckyDraw = (id, data) => ({
  type: actionTypes.REMOVE_LUCKY_DRAW,
  id,
  data
});

export const removeLuckyDrawSuccess = () => ({
  type: actionTypes.REMOVE_LUCKY_DRAW_SUCCESS
});

export const removeLuckyDrawFail = () => ({
  type: actionTypes.REMOVE_LUCKY_DRAW_FAIL
});

export const createLuckyDrawPrize = (id, data) => ({
  type: actionTypes.CREATE_LUCKY_DRAW_PRIZE,
  id,
  data
});

export const createLuckyDrawPrizeSuccess = () => ({
  type: actionTypes.CREATE_LUCKY_DRAW_PRIZE_SUCCESS
});

export const createLuckyDrawPrizeFail = () => ({
  type: actionTypes.CREATE_LUCKY_DRAW_PRIZE_FAIL
});

export const updateLuckyDrawPrize = (id, data) => ({
  type: actionTypes.UPDATE_LUCKY_DRAW_PRIZE,
  id,
  data
});

export const updateLuckyDrawPrizeSuccess = () => ({
  type: actionTypes.UPDATE_LUCKY_DRAW_PRIZE_SUCCESS
});

export const updateLuckyDrawPrizeFail = () => ({
  type: actionTypes.UPDATE_LUCKY_DRAW_PRIZE_FAIL
});

export const removeLuckyDrawPrize = (id, data) => ({
  type: actionTypes.REMOVE_LUCKY_DRAW_PRIZE,
  id,
  data
});

export const removeLuckyDrawPrizeSuccess = () => ({
  type: actionTypes.REMOVE_LUCKY_DRAW_PRIZE_SUCCESS
});

export const removeLuckyDrawPrizeFail = () => ({
  type: actionTypes.REMOVE_LUCKY_DRAW_PRIZE_FAIL
});

export const loadLuckyDrawPrize = (id, data) => ({
  type: actionTypes.LOAD_LUCKY_DRAW_PRIZE,
  id,
  data
});

export const loadLuckyDrawPrizeSuccess = data => ({
  type: actionTypes.LOAD_LUCKY_DRAW_PRIZE_SUCCESS,
  data
});

export const loadLuckyDrawPrizeFail = () => ({
  type: actionTypes.LOAD_LUCKY_DRAW_PRIZE_FAIL
});

export const loadLuckyDrawParticipant = (id, data) => ({
  type: actionTypes.LOAD_LUCKY_DRAW_PARTICIPANT,
  id,
  data
});

export const loadLuckyDrawParticipantSuccess = data => ({
  type: actionTypes.LOAD_LUCKY_DRAW_PARTICIPANT_SUCCESS,
  data
});

export const loadLuckyDrawParticipantFail = () => ({
  type: actionTypes.LOAD_LUCKY_DRAW_PARTICIPANT_FAIL
});

export const updateLuckyDrawParticipantEligible = (id, data) => ({
  type: actionTypes.UPDATE_LUCKY_DRAW_PARTICIPANT_ELIGIBLE,
  id,
  data
});

export const updateLuckyDrawParticipantEligibleSuccess = () => ({
  type: actionTypes.UPDATE_LUCKY_DRAW_PARTICIPANT_ELIGIBLE_SUCCESS
});

export const updateLuckyDrawParticipantEligibleFail = () => ({
  type: actionTypes.UPDATE_LUCKY_DRAW_PARTICIPANT_ELIGIBLE_FAIL
});

export const loadLuckyDrawResult = (id, data) => ({
  type: actionTypes.LOAD_LUCKY_DRAW_RESULT,
  id,
  data
});

export const loadLuckyDrawResultSuccess = data => ({
  type: actionTypes.LOAD_LUCKY_DRAW_RESULT_SUCCESS,
  data
});

export const loadLuckyDrawResultFail = () => ({
  type: actionTypes.LOAD_LUCKY_DRAW_RESULT_FAIL
});